import { createAction, createSelector, createSlice } from '@reduxjs/toolkit'
import i18n from '../../i18n'

const initialState = {
  churchLoading: true,
  servicesLoading: true,
  favoriteLoading: true,
  services: [],
  church: null,
}

export const startLoading = createAction('church/startLoading')
export const setIsLikedAsync = createAction('church/set-is-liked-async')

export const selectServices = state => state.church.services

export const selectOrders = createSelector(selectServices, services =>
  services.filter(s => 
    s.choice === i18n.t('orders.request') || 
    s.choice === 'Замовити' || 
    s.choice === 'Request' || 
    s.choice === 'Richiedi'
  )
)

export const selectSupports = createSelector(selectServices, services =>
  services.filter(s => 
    s.choice === i18n.t('orders.donate') || 
    s.choice === 'Підтримати' || 
    s.choice === 'Donate' || 
    s.choice === 'Sostieni'
  )
)

export const churchSlice = createSlice({
  name: 'church',
  initialState,
  reducers: {
    setChurchLoading(state, { payload }) {
      state.churchLoading = payload
    },
    setServicesLoading(state, { payload }) {
      state.servicesLoading = payload
    },
    setFavoriteLoading(state, { payload }) {
      state.favoriteLoading = payload
    },
    setServices(state, { payload }) {
      state.services = payload
    },
    setChurch(state, { payload }) {
      state.church = payload
    },
    setIsLiked(state, { payload }) {
      state.church = { ...state.church, isLiked: payload }
    },
  },
})

export const {
  setServices,
  setServicesLoading,
  setFavoriteLoading,
  setChurchLoading,
  setChurch,
  setIsLiked,
} = churchSlice.actions

export default churchSlice.reducer
